import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const BASE_URL = environment.BASE_URL + 'recoomendationpricing/'

@Injectable({
  providedIn: 'root',
})
export class RecommendedPricingService {
  private http = inject(HttpClient);

  getQuoteLine(liveQuoteId: string): Observable<any> {
    const url = `${BASE_URL}getquoteline?sf_quote_id=${liveQuoteId}`;
    const res = this.http.get(url);
    return res;
  }

  getLiveQuotes(): Observable<any> {
    const url = `${BASE_URL}get-live-quotes`;
    const res = this.http.get(url);
    return res;
  }
}
